"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/// <reference path="./ListControl.d.ts" />
const MethodManager_1 = require("../../../TdWebtoolkitControls/controls/Menu/MethodManager");
const Utilities_1 = require("../../javascript/Utilities");
const Base_1 = require("../../model/Base");
require("./ListControl.less");
const ListControlTemplate = require("./ListControl.tmpl.htm");
class ListControlImpl {
    static init($elem, options) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = ListControlImpl.getData($this);
            if (!synData) {
                synData = $.extend({}, ListControlImpl.DefaultOptions, options);
                if (synData.sort && synData.sort.sortOrder == undefined)
                    synData.sort.sortOrder = "ascending";
                ListControlImpl.setData($this, synData);
                $this.trigger("beginInit");
                try {
                    $this.addClass("synListControl").trigger("initSuccess");
                }
                finally {
                    $this.trigger("endInit");
                }
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            $(this).removeClass("synListControl").empty().removeData("synListControl");
        });
    }
    static setDataAsync($elem, instanceGen) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                let synData = ListControlImpl.getData($elem);
                $elem.trigger("beginGetData");
                $elem.addClass("loading").html("");
                let $container = ListControlImpl.getContainer($elem).html("");
                $container.append($("<img class='loadingImg' alt='Loading' src='assets/images/loading_image.gif'/>"));
                let instances = yield instanceGen;
                $elem.trigger("dataReceived");
                $container.html("");
                if (synData.sort)
                    instances.sort((a, b) => ListControlImpl.compareItems(a, b, synData.sort));
                $elem.removeClass("loading");
                ListControlImpl.addInstances($elem, instances, synData);
                ListControlImpl.afterFetch($elem);
            }
            catch (err) {
                $elem.trigger("getDataError", err);
            }
            finally {
                $elem.trigger("endGetData");
            }
        });
    }
    //#region Helpers
    static afterFetch($elem) {
        $elem.find(".listItemMethodButton > .wrapper").on("click", (ev) => {
            const method = $(ev.target).closest(".listItemMethodButton").attr("data-method");
            const id = $(ev.target).closest(".listItem").attr("data-id");
            MethodManager_1.MethodManager.executeMethod(method, [id], undefined, 0, undefined, { newWindow: true });
        });
        $elem.find(".detailElem.value").each((_idx, elem) => {
            if (elem.scrollWidth > elem.clientWidth)
                elem.title = elem.innerText;
        });
    }
    static compareItems(leftItem, rightItem, sort) {
        const asc = sort.sortOrder === "ascending";
        const a = asc ? leftItem : rightItem;
        const b = asc ? rightItem : leftItem;
        if (a.items[sort.fieldName] && b.items[sort.fieldName] && !a.items[sort.fieldName].multiValue) {
            const t = a.items[sort.fieldName].type;
            const aVal = a.items[sort.fieldName].value;
            const bVal = b.items[sort.fieldName].value;
            // Null early exit
            if (aVal == undefined) {
                if (bVal != undefined)
                    return -1;
                return 0;
            }
            else if (bVal == undefined)
                return 1;
            if (t === Base_1.FieldType.Date || t === Base_1.FieldType.Time || t === Base_1.FieldType.DateTime || t === Base_1.FieldType.Digit || t === Base_1.FieldType.BigDigit || t === Base_1.FieldType.Float) {
                return Math.abs(Number(aVal) - Number(bVal));
            }
            // String fallback, also used for fields that should not be compared (MV fields, FTKey fields, ImageValue fields etc.)
            return aVal.toString().localeCompare(bVal.toString());
        }
        return 0;
    }
    static getContainer($this) {
        let $container = $this.children(".container");
        if (!$container.length)
            $container = $("<div class='container'></div>").appendTo($this);
        return $container;
    }
    static getText(instance, fieldName) {
        let strReturn = "";
        let fieldReturn = undefined;
        switch (fieldName) {
            case "name":
                fieldReturn = instance.name;
                break;
            case "treename":
                fieldReturn = instance.treename;
                break;
            case "icon":
                fieldReturn = instance.icon;
                break;
            case "id":
                fieldReturn = instance.id;
                break;
            case "comment":
                fieldReturn = instance.comment;
                break;
            default:
                fieldReturn = instance.items[fieldName];
                break;
        }
        if (!fieldReturn)
            return "";
        let t = fieldReturn.type;
        if (fieldReturn.multiValue)
            return fieldReturn.valueAsArray
                .map((v) => ListControlImpl.getTextCore(v, t))
                .join(";");
        else {
            return ListControlImpl.getTextCore(fieldReturn.value, t);
        }
    }
    static getTextCore(singleValue, fieldType) {
        if (singleValue == undefined)
            return "";
        else if (fieldType === Base_1.FieldType.Time)
            return kendo.toString(singleValue, "T");
        else if (fieldType === Base_1.FieldType.Date)
            return kendo.toString(singleValue, "d");
        else if (fieldType === Base_1.FieldType.DateTime)
            return kendo.toString(singleValue, "G");
        else if (fieldType === Base_1.FieldType.Bool)
            return singleValue ? "Y" : "N";
        else if (fieldType === Base_1.FieldType.Float)
            return kendo.toString(singleValue, "n2");
        return singleValue.toString();
    }
    static addInstances($this, instances, synData) {
        let tmpl = kendo.template(ListControlTemplate);
        let arr = [];
        for (const inst of instances) {
            arr.push($(tmpl({
                instance: inst,
                synUtil: Utilities_1.synUtil,
                kendo: kendo,
                title: ListControlImpl.getText(inst, synData.titleProperty),
                detailProperties: synData.detailsProperties,
                detailValues: synData.detailsProperties.map(p => ListControlImpl.getText(inst, p)),
                methods: synData.methods
            })));
        }
        ListControlImpl.getContainer($this).append(arr);
    }
    static setData($this, data) {
        $this.data("synListControl", data);
    }
    static getData($this) {
        return $this.data("synListControl");
    }
}
/**
 * Contains all default values for option parameters not passed by the caller
 */
ListControlImpl.DefaultOptions = {
    methods: [],
    titleProperty: "name",
    detailsProperties: []
};
// Dispatcher code
(($) => {
    $.fn.synListControl = function () {
        // Dispatch to init function
        if (!arguments.length || typeof arguments[0] === "object")
            return ListControlImpl.init.apply(undefined, [this].concat(Array.prototype.slice.call(arguments)));
        // Dispatch to all other functions, if they exist
        else if (typeof arguments[0] === "string" && ListControlImpl[arguments[0]])
            return ListControlImpl[arguments[0]].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else
            $.error("Method " + arguments[0] + " does not exist on jQuery.synListControl");
    };
})(jQuery);
